<div class="registry-dialog flex flex-col">
  <div class="registry-dialog-header flex justify-between items-center">
    <div class="registry-dialog-title">Add registry entry</div>
    <mat-icon (click)="cancel()" class="registry-dialog-close" data-testid="registry-dialog-close">close</mat-icon>
  </div>
  <div class="registry-dialog-body">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['section_no']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="section_no"
      label="Section No"
      />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['sub_section_no']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="sub_section_no"
      label="Sub Section No"
      />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['title']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="title"
      label="title"
      />
    <app-text-area
      [parentFormGroup]="form"
      class="w-full"
      controlName="description"
      label="description"
      />
    @if (saveError) {
      <div class="registry-dialog-error text-type-14" data-testid="registry-dialog-error">{{ saveError }}</div>
    }
  </div>
  <div class="registry-dialog-footer flex gap-[16px]">
    <app-secondary-button (handleClick)="cancel()" class="flex-1">Cancel</app-secondary-button>
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="saving"
      [isLoading]="saving"
      buttonId="registry-dialog-save"
      class="flex-1"
      >Add</app-primary-button>
  </div>
</div>
